<ek-dialog-header>
    <h4 style="color:rgba(11,119,73,1); font-weight:400;">{{ title | translate }}</h4>
</ek-dialog-header>

<ek-dialog-body class="p-4 text-gray-700 flex justify-center items-center text-center h-full w-full overflow-hidden">
    <p>
       {{ message }}
    </p>
</ek-dialog-body>

<ek-dialog-footer>
    <ek-button 
        class="mr-4" 
        (click)="onCancel()" 
        [label]="'LABELS.CANCEL' | translate" 
        [ekStyle]="'outlined'" 
        [severity]="'success'">
    </ek-button>
    
    <ek-button 
        (click)="onConfirm()" 
        [label]="'LABELS.DELETE' | translate" 
        [ekStyle]="'filled'"
        [severity]="'danger'"
        [disabled]="disableConfirmation">
    </ek-button>
</ek-dialog-footer>